import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5 6a1 1 0 0 1 1 1v6.5h11V7a1 1 0 1 1 2 0v15a1 1 0 1 1-2 0v-6.5H6V22a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M28.512 11.641a1 1 0 0 1 .347 1.371l-2.083 3.494q.111-.006.224-.006a4.5 4.5 0 1 1-3.74 1.998l3.881-6.51a1 1 0 0 1 1.371-.347m-3.72 8.187a2.5 2.5 0 1 0 .153-.251l-.111.185z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconTextHSix = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconTextHSix);
export default Memo;
